import React from "react";
import { Image } from "react-bootstrap";
import spinner from "../../../images/3drops-spinner.png";

const LoadingSpinner = () => {
  return (
    <section className="spinner-wrapper">
      <Image
        src={spinner}
        alt="Loading..."
        className="spinner-image"
        width={120}
        height={120}
      />
    </section>
  );
};

export default LoadingSpinner;
